/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { v1 as uuidv1 } from 'uuid';
import { api } from '@seaoil/component-lib';

import AsyncAutoComplete from './AsyncAutoComplete';

const { mySEAOIL } = api;

function ExpenseSubCategory3Field({
  // attributes
  style,
  placeholder,
  disabled,

  // object attributes
  config: {
    company_code,
    category,
    subcategory_1,
    subcategory_2,
  },

  // methods
  onInputSelect,
}) {
  const [subCategories, setSubCategories] = useState([]);
  const [loading, isLoading] = useState(false);
  const [key, setKey] = useState(uuidv1());
  const [options, setOptions] = useState([]);
  const retryLimit = 5;
  let retryCount = 0;

  const loadSubCategories = async () => {
    isLoading(true);
    try {
      const subCats = await mySEAOIL.datawarehouse.getExpenseAcctEntry({
        attribute: 'subcategory_3',
        parameters: {
          company_code,
          category,
          subcategory_1,
          subcategory_2,
        },
      }).send();
      setSubCategories(subCats);
    } catch (e) {
      if (retryCount > retryLimit) {
        notification.error({ message: 'Unable to load subcategory 3 after multiple retries. Kindly contact supportdesk@seaoil.com.ph' });
      } else {
        notification.error({ message: 'Unable to load subcategory 3. Retrying after 2 seconds...' });
        setTimeout(loadSubCategories, 2000);
        retryCount += 1;
      }
    } finally {
      isLoading(false);
    }
  };

  useEffect(() => {
    setKey(uuidv1());
    setOptions([]);
    if (company_code
      && category
      && subcategory_1
    ) {
      loadSubCategories();
    }
  }, [company_code, category, subcategory_1, subcategory_2]);

  useEffect(() => {
    if (!Array.isArray(subCategories)) {
      return;
    }

    setOptions(subCategories.map(({
      subcategory_3,
    }) => ({
      value: subcategory_3,
      label: subcategory_3,
    })));
  }, [subCategories]);

  return (
    <AsyncAutoComplete
      key={key}
      style={style}
      placeholder={placeholder}
      loading={loading}
      disabled={disabled}
      options={options}
      onInputSelect={(subcat3) => {
        if (subCategories) {
          onInputSelect(subCategories.find(({ subcategory_3 }) => subcategory_3 === subcat3));
        }
      }}
    />
  );
}

export default ExpenseSubCategory3Field;
